import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import LiveTvIcon from '@material-ui/icons/LiveTvOutlined';

import { translate } from 'services/i18nService';
import ModalService from 'services/ModalService';
import ProfileStore from 'stores/ProfileStore';
import Button from 'components/Button/Button';

import styles from './ProfileBanner.css';


function RealityEventButton(props) {
  const { user: { accessLevel, username } } = props;
  const { mainEventUsername, realityShow } = ProfileStore;

  const minAccessLevel = realityShow?.config?.minAccessLevel || 0;

  const onGoToMainEvent = useCallback(() => {
    const hasAccessLevel = accessLevel >= minAccessLevel;
    const isLoggedIn = username !== null;

    if (!hasAccessLevel || !isLoggedIn) {
      ModalService.showModal(ModalService.MODAL_KEYS.UPGRADE_TO_GOLD_MODAL_V2);

      return;
    }

    window.open(`/${mainEventUsername}`, '_blank');
  }, [
    accessLevel,
    mainEventUsername,
    minAccessLevel,
    username,
  ]);

  return (
    <Button
      className={styles.profileButton}
      colour="white"
      icon={<LiveTvIcon />}
      id="goToMainEventButton"
      label={translate('v2profile.go.to.main.event')}
      size="small"
      onClick={onGoToMainEvent}
    />
  );
}

RealityEventButton.propTypes = {
  user: PropTypes.object.isRequired,
};

export default observer(RealityEventButton);
